var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.503,
    height: 18.806,
    viewBox: "0 0 23.503 18.806",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 18.305) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.008,13.264,9.37,20.9V.469a.469.469,0,1,0-.938,0V20.9L.795,13.264a.469.469,0,0,0-.663.663L8.57,22.365a.469.469,0,0,0,.663,0h0l8.439-8.439a.469.469,0,0,0-.663-.663Z",
    transform: "translate(0.001 0)",
    fill: "#f0faf5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9,23a.962.962,0,0,1-.686-.285L-.228,14.274a.965.965,0,0,1,0-1.346.974.974,0,0,1,.7-.3.964.964,0,0,1,.673.272l.006.006L7.932,19.7V.469a.969.969,0,0,1,1.938,0V19.7L16.8,12.769h.045a.969.969,0,0,1,1.192,1.506l-.006.006L9.588,22.719A.964.964,0,0,1,8.9,23Z",
    transform: "translate(0.001 0)",
    fill: "#f0faf5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9,9.37a.469.469,0,0,1-.332-.137L.132.795A.469.469,0,0,1,.794.132L8.9,8.238,17.009.132a.469.469,0,0,1,.663.663L9.233,9.233A.469.469,0,0,1,8.9,9.37Z",
    transform: "translate(0 13.133)",
    fill: "#f0faf5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9,9.87h0a.962.962,0,0,1-.684-.283L-.228,1.142A.962.962,0,0,1-.5.452.969.969,0,0,1,.469-.5a.964.964,0,0,1,.673.272l.006.006L8.9,7.531,16.662-.228A.964.964,0,0,1,17.335-.5a.974.974,0,0,1,.7.3.965.965,0,0,1,0,1.346l-.006.006L9.587,9.587A.963.963,0,0,1,8.9,9.87Z",
    transform: "translate(0 13.133)",
    fill: "#f0faf5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.469,22.5A.469.469,0,0,1,0,22.034V.469a.469.469,0,0,1,.938,0V22.035A.469.469,0,0,1,.469,22.5Z",
    transform: "translate(8.433 0)",
    fill: "#f0faf5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.469,23A.97.97,0,0,1-.5,22.034V.469a.969.969,0,0,1,1.938,0V22.035A.97.97,0,0,1,.469,23Z",
    transform: "translate(8.433 0)",
    fill: "#f0faf5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.2ceaa842f113db5fc6986e22883ca833.svg";
export { ForwardRef as ReactComponent };